var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('el-tabs',{attrs:{"tab-position":"left"}},_vm._l((_vm.appData),function(item){return _c('el-tab-pane',{key:item.name,attrs:{"label":item.appName}},[_c('role-table',{attrs:{"tableData":item.data,"appId":item.appId,"storeType":_vm.storeType}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }